import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-pipelines'
import { ExecuteOperationOnPipe } from '@morningtrain/react-resources'
import RefreshForcedNotificationsOnPipe from './RefreshForcedNotificationsOnPipe'
import { Translation } from '@morningtrain/react-translations'
import ForcedNotificationWrapper from 'widgets/forced-notifications/partials/ForcedNotificationWrapper'

export default function ForcedMessage ({ message }) {
  return (
    <ForcedNotificationWrapper>
      <UI.CardHeader>
        <UI.PrimaryHeading>
          <Displays.Text defaultValue={message.subject} />
        </UI.PrimaryHeading>
      </UI.CardHeader>

      <Displays.Html defaultValue={message.content_long} />

      <UI.ButtonWrap leftAlign>
        <Pipeline>
          <TriggerPipelineOnClick>
            <UI.Button>
              <Translation name='generic.continue' />
            </UI.Button>
          </TriggerPipelineOnClick>
          <ExecuteOperationOnPipe
            namespace='api'
            resourceName='messages.messages'
            operationName='mark_as_read'
            routeParameters={{ message: message.id }}
          />
          <RefreshForcedNotificationsOnPipe />
        </Pipeline>
      </UI.ButtonWrap>

    </ForcedNotificationWrapper>
  )
}
